/**
 * Item IDs shown to visitors without an active plan.
 *
 * `fetchPagedItems` in src/util/db.js uses the paged `createdAt desc` query
 * only when `isSubscriber` is true; everyone else gets
 * `where(documentId(), "in", featuredImages)`. So this list IS the entire
 * gallery for anonymous and free users — the shop window.
 *
 * The previous 10 IDs had all been deleted from the `items` collection, so the
 * query returned 0 documents and the gallery rendered empty for every
 * non-subscriber.
 *
 * Firestore caps an `in` query at 10 values — do not add an 11th.
 *
 * Each entry below was verified to: exist, have `isPrivate: false`, have a
 * non-empty `userPrompt` (Gallery.js reads `.length` on it unguarded), return
 * HTTP 200 from Storage, and carry a caption safe to display publicly.
 * If you replace these, re-check all five.
 */
const featuredImages = [
  "nuca3aG0aDz9KiJxa0yq", // real      — beautiful brunette girl
  "QGANaEx3klDee5WrtJyK", // real      — beautiful pakistani girl
  "TigGGELFXcJMSRwlWiwA", // real      — beautiful asian girl
  "ftYJZpLUapnCaB08aySo", // hyperreal — skinny girl, slender, athletic
  "qtGti3pcYE0sXLJZozAd", // real      — thick brunette girl
  "SBqK0N4oHQVuPCiA449h", // hyperreal — curvy busty iranian girl
  "aR13xJjtooFqeei6QhWO", // hyperreal — gorgeous brown haired girl
  "h1pXcvaYGrJTaQzHskYs", // hyperreal — beautiful nude brunette girl
  "1LwhOtByirFikX2q5VIo", // real      — beautiful blonde girl
  "kYyyAAYbtK8cBXlMpSVQ", // real      — bbw nude woman
];

export default featuredImages;
